<style lang="less">
.lsItem {
  width: 100%;
  clear: both;
}
.omBox {
  position: relative;
  top: 0;
  left: 0;
  clear: both;
  width: 100%;

  &--0 {
    padding-top: 0rem;
  }

  &--0:before {
    top: 0rem;
  }

  &__date {
    position: absolute;
    left: 0;
    text-align: right;
    width: 0.9rem;
    top: 0.25rem;
  }

  &__showMon {
    font-weight: normal;
    display: block;
    line-height: 1.2;
    color: #4c4c4c;
    font-size: 0.28rem;
  }

  &__showYear {
    color: #959595;
    font-size: 0.20rem;
  }

  &__main {
    padding-left: 1.1rem;
  }
}
.active {
  .omBox__showMon,
  .omBox__showYear {
    color: #3f8eed;
  }

  .omAudio__doneSecs,
  .omAudio__progress {
    visibility: visible;
  }
}
</style>
<template>
  <div class="lsItem clearfix">
    <div class="omAdv" v-if="advNo">
      <k-adv page-key="/biz/wz/oneminute/list/" :pos-key="`ban-${advNo}`" />
    </div>
    <div class="omBox" v-if="item" :class="{active: curOid === item.oid}">
      <div class="omBox__date" v-if="item.showDate">
        <strong class="omBox__showMon">{{item.showDate.slice(5, 10)}}</strong>
        <small class="omBox__showYear">{{item.showDate.slice(0,4)}}</small>
      </div>
      <div class="omBox__main">
        <audio-item :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AudioItem from "./audio-item";
export default {
  components: {
    AudioItem,
  },
  props: ["item", "advNo"],
  computed: {
    ...mapGetters("oneminute", ["curOid"]),
  },
};
</script>
